class ShCheckout {
    static config = JSON.parse(window.atob(window.hc_config));

    static async processCheckout(items, button) {
        let hideSpinner;

        try {
            hideSpinner = this.showButtonSpinner(button);
            const response = await fetch(`https://${this.config.host}/checkout`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items,
                    attributions: {
                        fbc: this.getCookie('_fbc'),
                        fbp: this.getCookie('_fbp'),
                        clid: localStorage.getItem('sh_clid'),
                        params: localStorage.getItem('sh_params'),
                        ttp: this.getCookie('_ttp'),
                        ttclid: localStorage.getItem('sh_ttclid') ?? this.getCookie('ttclid'),

                    }
                }),
            });

            if (!response.ok) {
                throw new Error('Unable to create checkout.');
            }

            const { checkout_url: checkoutUrl } = await response.json();

            if (!checkoutUrl) {
                throw new Error('Checkout URL was not returned.');
            }

            window.location.assign(checkoutUrl);
        } catch (error) {
            hideSpinner?.();
            console.log(error);
            window.alert('Unable to start checkout. Please try again.');
        }
    }

    /**
     *
     * @param {HTMLFormElement} formEl
     * @param {SubmitEvent} event
     */
    static handleFormSubmit(formEl, event) {
        event.preventDefault();
        event.stopPropagation();

        const formData = new FormData(formEl);
        const items = [];

        formData.entries().forEach(([name, value]) => {
            if (name === 'sh_checkout_item') {
                const [variant_id, quantity] = value.split('|');
                items.push({ variant_id, quantity });
            }
        });

        if (items.length === 0) {
            items.push({
                variant_id: formData.get('id'),
                quantity: formData.get('quantity') ?? 1,
            });
        }

        this.processCheckout(items, event.submitter);
    }

    static usesSelfHostedCheckout() {
        try {
            const params = JSON.parse(localStorage.getItem('sh_params') || '{}');

            return typeof params.utm_campaign === 'string' && params.utm_campaign.startsWith('sh_');
        } catch {
            return false;
        }
    }

    static getCookie(name) {
        return document.cookie
            .split('; ')
            .find((cookie) => cookie.startsWith(`${name}=`))
            ?.split('=')
            .slice(1)
            .join('=') ?? null;
    }

    static showButtonSpinner(button) {
        const originalPosition = button.style.position;
        const originalDisabled = button.disabled;
        const originalPointerEvents = button.style.pointerEvents;

        button.style.position = 'relative';
        button.style.pointerEvents = 'none';
        button.disabled = true;

        const overlay = document.createElement('div');

        Object.assign(overlay.style, {
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: '10',
            borderRadius: 'inherit',
        });

        const spinner = document.createElement('div');

        Object.assign(spinner.style, {
            width: '16px',
            height: '16px',
            border: '2px solid rgba(255, 255, 255, 0.4)',
            borderTopColor: '#fff',
            borderRadius: '50%',
            flexShrink: '0',
        });

        overlay.append(spinner);
        button.appendChild(overlay);

        let rotation = 0;
        let animationFrame;

        const animate = () => {
            rotation = (rotation + 6) % 360;
            spinner.style.transform = `rotate(${rotation}deg)`;
            animationFrame = requestAnimationFrame(animate);
        };

        animate();

        return function hideSpinner() {
            cancelAnimationFrame(animationFrame);
            overlay.remove();

            button.style.position = originalPosition;
            button.style.pointerEvents = originalPointerEvents;
            button.disabled = originalDisabled;
        };
    }
}

const usesSelfHostedCheckout = true;

document.querySelectorAll('[data-sh-checkout-button]').forEach((button) => {
    button.hidden = !usesSelfHostedCheckout;
});

document.querySelectorAll('[data-native-checkout-button]').forEach((button) => {
    button.hidden = usesSelfHostedCheckout;
});

document.addEventListener('submit', (event) => {
    const form = event.target.closest('form');

    if (!form || !event.submitter.hasAttribute('sh-checkout')) {
        return;
    }

    if (usesSelfHostedCheckout) {
        ShCheckout.handleFormSubmit(form, event);
    }
}, true);
